import { Link } from "react-router-dom";
import { Box, Button, Grow, Typography } from "@mui/material";
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';

const RenderSuccessStep = () => (
    <Grow in timeout={800}>
        <Box textAlign="center">
            <CheckCircleIcon
                sx={{
                    fontSize: 64,
                    color: 'success.main',
                    mb: 2,
                }}
            />
            <Typography variant="h6" gutterBottom color="success.main">
                Senha redefinida com sucesso!
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
                Sua senha foi alterada com sucesso. Agora você pode fazer login com sua nova senha.
            </Typography>

            <Box>
                <Link to="/login">
                    <Button
                        variant="contained"
                        color="success"
                        fullWidth
                    >
                        Fazer Login
                    </Button>
                </Link>
            </Box>
        </Box>
    </Grow>
);

export default RenderSuccessStep;